import type { oz } from '@weft/utils';
import { NewContractSchema } from './new-contract-schema';

export const ContractInputSchema = NewContractSchema.partial().openapi('ContractInput');

export type ContractInput = oz.infer<typeof ContractInputSchema>;